function TalkToHackneyNightsController(){
	this.glob		= "/talk-to-hackney-nights**";
	this.submissionUrl = "/forms/talk-to-hackney-nights";
};
TalkToHackneyNightsController.inheritsFrom( ContactController );